import { render, staticRenderFns } from "./addDictionaries.vue?vue&type=template&id=2e3f39be&scoped=true&"
import script from "./addDictionaries.vue?vue&type=script&lang=js&"
export * from "./addDictionaries.vue?vue&type=script&lang=js&"
import style0 from "./addDictionaries.vue?vue&type=style&index=0&id=2e3f39be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3f39be",
  null
  
)

export default component.exports